import { autoinject, bindingMode } from 'aurelia-framework';
import { ComponentBase, SortDirection, Sorting, StandardLoadOptions } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { AuthService } from 'app/cd/services/auth-service';
import { apiCall } from 'app/shared/lib/api/api';
import * as CD from 'app/cd/models/essette-api';
import { EssPagerCustomElement } from 'app/shared/elements/ess-pager';
import { SortChangeEvent } from 'app/shared/attributes/sortable-attribute';

@autoinject()
export class MemberImportedServicesGrid extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.stringNull({ defaultBindingMode: bindingMode.toView, changeHandler: 'reload' })
    public authId: string | null = null;

    @bindable({ defaultBindingMode: bindingMode.toView })
    protected pageSize: number | undefined = 10;

    private sorting: Sorting = new Sorting();

    protected services: CD.Service[] = [];
    protected serviceResultCount: number = 0;

    ////****************** Element References ***************************************////
    protected $pagerServices!: EssPagerCustomElement;

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly authService: AuthService,
        ...rest: any[]) {

        super(...rest);

        this.sorting.entries = [
            {
                reference: 'description',
                direction: SortDirection.Ascending
            }
        ];
    }

    protected bind(): void {
        this.reload();
    }

    ////****************** Events ***************************************************////
    public async reload(): Promise<void> {
        await this.loadAuthServices();
    }

    protected applySort(event: SortChangeEvent): void {
        const { property, direction } = event.detail;
        const { sorting } = this;
        if(direction === null) {
            sorting.remove(property);
        } else {
            sorting.add({
                reference: property,
                direction: direction === 'asc' ? SortDirection.Ascending : SortDirection.Descending
            });
        }
        this.reload();
    }

    ////****************** Functions ************************************************////

    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadAuthServices(): Promise<void> {
        if(!this.authId) return;

        const includes: string[] = [
            'detail.modifiers'
        ];

        const fields: string[] = [
            'code',
            'description',
            'detail.charge.approved',
            'detail.charge.requested',
            'detail.modifiers.description',
            'detail.quantity.approved',
            'detail.quantity.requested',
            'detail.quantity.utilized'
        ];

        const options: StandardLoadOptions = {
            sorting: this.sorting,
            top: this.pageSize,
            page: this.$pagerServices?.page || 0,
            includeInactive: false
        };

        try {
            this.state.beginLoad();

            const responseServices = await this.authService.loadAuthServices(this.authId, options, includes, fields);
            this.services = responseServices.results;
            this.serviceResultCount = responseServices.count || 0;
        } catch(error) {
            throw error;
        } finally {
            this.state.endLoad();
        }
    }
}
